import moment from "moment";
import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLoader } from "../../Loader";

function Add(props) {
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [plantLocation, setPlantLocation] = useState("");
  const [plantList, setPlantList] = useState([]);
  const [poItems, setPoItems] = useState([]);
  const [poNumber, setPoNumber] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [storeQuantities, setStoreQuantities] = useState([]);
  const [qcQuantities, setQcQuantities] = useState([]);
  const [head, setHead] = useState("");
  const [remark, setRemark] = useState("");
  const [qcremark, setqcRemark] = useState("");
  const { startLoader, stopLoader } = useLoader();
  const [storeQtyErrors, setStoreQtyErrors] = useState([]);
  const [qcQtyErrors, setQcQtyErrors] = useState([]);

  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state.userProfile.userProfile);

  const [isQc, setIsQc] = useState(false);
  useEffect(() => {
    getPlantList();
  }, []);

  useEffect(() => {
    if (primaryMenuRes) {
      if (utils.hasPermission(primaryMenuRes, "Invert", "invert.list_for_QC")) {
        setIsQc(true);
      } else {
        setIsQc(false);
      }
    }
  }, [primaryMenuRes]);

  const getPlantList = () => {
    utils
      .callAPI("get", `/purchaseorder/plant/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setPlantList(res?.result);
        } else {
          setPlantList([]);
        }
      })
      .catch((err) => {
        setPlantList([]);
      });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    const hasErrors =
      storeQtyErrors.some((err) => !!err) || qcQtyErrors.some((err) => !!err);

    if (form.checkValidity() === false || hasErrors) {
      e.stopPropagation();
      setValidated(true);
      return; // prevent submission
    }

    setIsSubmit(true);
  };

  useEffect(() => {
    if (isSubmit) {
      startLoader();
      var bodyFormData = new FormData();
      if (props.rowData && Object.keys(props.rowData).length > 0) {
        bodyFormData.append("id", props.rowData.id);
      }
      bodyFormData.append("po_id", poNumber);
      bodyFormData.append("invoice_no", invoiceNumber);
      bodyFormData.append("plant_id", plantLocation);
      bodyFormData.append("store_remark", remark);
      bodyFormData.append("qc_remark", qcremark);
      bodyFormData.append("capital_forward", head == "Capital" ? "1" : "0");
      bodyFormData.append("store_id", isQc ? 0 : userProfile?.id);
      bodyFormData.append("qc_id", isQc ? userProfile?.id : 0);

      const itemsWithStoreQty = poItems.map((item, index) => ({
        id: item?.eid ? item?.eid : 0,
        item_id: item.item_id,
        qty: item.qty,
        qty_storeBy: storeQuantities[index],
        qty_qcBy: isQc ? qcQuantities[index] : "",
      }));
      bodyFormData.append("item_qty", JSON.stringify(itemsWithStoreQty));

      utils
        .callAPI("post", `purchaseorder/add-invert-qty`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);

            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
            stopLoader();
          }
          setIsSubmit(false);
          stopLoader();
        })
        .catch((err) => {
          setIsSubmit(false);
          stopLoader();
        });
    }
  }, [isSubmit]);

  const handlePoBlur = () => {
    if (poNumber.trim() !== "") {
      utils
        .callAPI("get", `/purchaseorder/polist-store?po_id=${poNumber}`)
        .then((res) => {
          if (res) {
            if (res?.head_name !== "Capital") {
              setPoItems(res.result || []);
            }
            setHead(res?.head_name);
          }
        })
        .catch((err) => {
          setPoItems([]);
        });
    }
  };

  const handleStoreQtyChange = (index, value) => {
    const actualQty = poItems[index]?.qty || 0;
    const updatedQuantities = [...storeQuantities];
    const updatedErrors = [...storeQtyErrors];

    if (/^\d*\.?\d{0,4}$/.test(value)) {
      updatedQuantities[index] = value;

      if (Number(value) > Number(actualQty)) {
        updatedErrors[index] = `Quantity cannot be more than actual (${actualQty})`;
      } else {
        updatedErrors[index] = "";
      }

      setStoreQuantities(updatedQuantities);
      setStoreQtyErrors(updatedErrors);
    }
  };

  const handleQcQtyChange = (index, value) => {
    const storeQty = storeQuantities[index] || 0;
    const updatedQuantities = [...qcQuantities];
    const updatedErrors = [...qcQtyErrors];

    if (/^\d*\.?\d{0,4}$/.test(value)) {
      updatedQuantities[index] = value;

      if (Number(value) > Number(storeQty)) {
        updatedErrors[index] = `Quantity cannot be more than (${storeQty})`;
      } else {
        updatedErrors[index] = "";
      }

      setQcQuantities(updatedQuantities);
      setQcQtyErrors(updatedErrors);
    }
  };

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      setIsEdit(true);

      setPoNumber(props.rowData.order_id || "");
      setInvoiceNumber(props.rowData.invoice_no || "");
      setPlantLocation(props.rowData.plant_id || "");
      setRemark(props.rowData.remark || "");

      if (isQc) {
        setqcRemark(props.rowData.qc_remark);
      } else {
        setRemark(props.rowData.store_remark);
      }
      if (props.rowData.invert_item && props.rowData.invert_item.length > 0) {
        setPoItems(
          props.rowData.invert_item.map((item) => ({
            ...item,
            eid: item.id,
            product_name: item.product_name,
            product_code: item.product_code,
            // qty: item.qty_stoteBy,

            qty: item.qty,
            unit: "",
          }))
        );

        // utils
        // .callAPI("get", `/purchaseorder/polist-store?po_id=${props.rowData.order_id}`)
        // .then((res) => {
        //   if (res) {
        //     setPoItems(res.result || []);
        //   }
        // })
        // .catch((err) => console.error("Error fetching PO items:", err));
        setStoreQuantities(
          props.rowData.invert_item.map((item) => item.qty_storeBy || "")
        );
      }
    }
  }, [props.rowData]);

  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          <h4></h4>
          <div className="card-header-action">
            <Link className="btn btn-underline me-2" onClick={handleBackClick}>
              Back
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="PO Number"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter PO Number"
                      value={poNumber}
                      disabled={isQc}
                      onChange={(e) => setPoNumber(e.target.value)}
                      onBlur={handlePoBlur}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Invoice Number"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      disabled={isQc}
                      placeholder="Enter Invoice Number"
                      value={invoiceNumber}
                      onChange={(e) => setInvoiceNumber(e.target.value)}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              {head !== "Capital" && (
                <RB.Col md={6}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      controlId="plantLocation"
                      label="Plant Location"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Select
                        value={plantLocation}
                        onChange={(e) => setPlantLocation(e.target.value)}
                        required
                        disabled={isQc}
                      >
                        <option value="">Select Plant Location</option>
                        {plantList.map((plant) => (
                          <option key={plant.id} value={plant.id}>
                            {plant.plant_name}
                          </option>
                        ))}
                        {/* Add more options as necessary */}
                      </RB.Form.Select>
                      <RB.Form.Control.Feedback type="invalid">
                        Please select a plant location.
                      </RB.Form.Control.Feedback>
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              )}
            </RB.Row>
            {head !== "Capital" && (
              <>
                <RB.Row>
                  <div className="table-responsive">
                    <RB.Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Item Name</th>
                          <th>Item Code</th>
                          <th>Qty</th>
                          <th>Store Qty</th>
                          {isQc && <th>QC Qty</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {poItems.length !== 0 ? (
                          <>
                            {poItems.map((item, index) => (
                              <tr key={item.itemId}>
                                <td>{item.product_name}</td>
                                <td>{item.product_code}</td>
                                <td>{`${item.qty} (${
                                  item.unit ? item.unit : item?.unit_name
                                })`}</td>
                                <td>
                                  <RB.Form.Control
                                    type="text"
                                    readOnly={isQc}
                                    value={storeQuantities[index] || ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^\d*\.?\d{0,4}$/.test(value)) {
                                        handleStoreQtyChange(index, value);
                                      }
                                    }}
                                    isInvalid={!!storeQtyErrors[index]}
                                  />
                                  <RB.Form.Control.Feedback type="invalid">
                                    {storeQtyErrors[index]}
                                  </RB.Form.Control.Feedback>
                                </td>

                                {isQc && (
                                  <td>
                                    <RB.Form.Control
                                      type="text"
                                      placeholder="Enter QC Qty"
                                      value={qcQuantities[index] || ""}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*\.?\d{0,4}$/.test(value)) {
                                          handleQcQtyChange(index, value);
                                        }
                                      }}
                                      isInvalid={!!qcQtyErrors[index]}
                                    />
                                    <RB.Form.Control.Feedback type="invalid">
                                      {qcQtyErrors[index]}
                                    </RB.Form.Control.Feedback>
                                  </td>
                                )}
                              </tr>
                            ))}
                          </>
                        ) : (
                          <>
                            <tr className="text-center">
                              <td colSpan={isQc ? 5 : 4}>No Items found.</td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </RB.Table>
                  </div>
                </RB.Row>
                <RB.Row className="mt-3">
                  <RB.Col md={12}>
                    <div className="mb-3">
                      {isQc ? (
                        <>
                          <RB.FloatingLabel
                            label="Remark"
                            className="floating-label-fancy"
                          >
                            <RB.Form.Control
                              as="textarea"
                              placeholder="Enter any remarks here"
                              value={qcremark}
                              onChange={(e) => setqcRemark(e.target.value)}
                              rows={4}
                              required
                            />
                          </RB.FloatingLabel>
                        </>
                      ) : (
                        <>
                          <RB.FloatingLabel
                            label="Remark"
                            className="floating-label-fancy"
                          >
                            <RB.Form.Control
                              as="textarea"
                              placeholder="Enter any remarks here"
                              value={remark}
                              onChange={(e) => setRemark(e.target.value)}
                              rows={4}
                              required
                            />
                          </RB.FloatingLabel>
                        </>
                      )}
                    </div>
                  </RB.Col>
                </RB.Row>
              </>
            )}
            <RB.Row className="justify-content-start mt-3">
              <RB.Col className="col-auto">
                <RB.Button
                  variant="primary"
                  type="submit"
                  disabled={head !== "Capital" && poItems.length === 0}
                >
                  {head !== "Capital" ? "Submit" : "Forward"}
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
